<template>
    <div>
        <FormInput 
            label="Fecha baja:"
            name="Fecha baja"
            id="fecha_baja"
            type="date"
            v-model="form.fecha_baja"
            rules="required"
        />
        
        <FormInput
            label="Orientación Diagnóstica:"
            name="Orientación Diagnóstica"
            id="orientacion_diagnostica"
            type="text"
            v-model="form.orientacion_diagnostica"
            rules="required"
        />
        
        <FormInput
            label="Fecha alta:"
            name="Fecha alta"
            id="fecha_alta"
            type="date"
            v-model="form.fecha_alta"
            rules="required"
        />
    </div>
</template>

<script>
    export default {
        props: [
            'form'
        ]
    }
</script>